import DisplayNotesOrLogs from './DisplayNotesOrLogs';

export default DisplayNotesOrLogs;
